// Unique, Barcelona-targeted content for the hotel flower delivery landing page (RU/EN only).
// Written from scratch — NOT a copy of Istanbul/Bangkok. Prices in EUR (city currency).

// Curated hotel bouquets selected by stable Russian name (ids differ per environment).
export const BARCELONA_HOTEL_PRODUCT_NAMES = [
  "Широкие Объятия",
  "Поцелуй Любви",
  "Экзотический Бриз",
  "Утренний Свет",
  "Трепет Души",
  "Летний Сад",
  "Алое Искушение",
  "Композиция Венеция",
];

export const barcelonaHotelContent = {
  ru: {
    metaTitle: "Доставка цветов в отели Барселоны — букет в номер к приезду | YUCCA",
    metaDescription:
      "Доставка цветов в отели Барселоны: букет в номер к заезду, сюрприз к годовщине, вручение через ресепшен. Отели на Пасео де Грасия, в Готическом квартале, Эшампле и Барселонете. Фото перед вручением, оплата из любой страны. Заказ в WhatsApp.",
    waCity: "в Барселоне",
    breadcrumb: { home: "Главная", city: "Барселона", current: "Цветы в отели" },
    h1: "Доставка цветов в отели Барселоны",
    heroLead:
      "Хотите, чтобы букет ждал в номере к приезду близкого человека, встретил гостей на ресепшене или стал сюрпризом к годовщине в отеле Барселоны? YUCCA Flowers доставляет свежие цветы в отели по всему городу — от люксовых гостиниц на Пасео де Грасия и бутик-отелей Готического квартала до пляжных отелей Барселонеты. Мы согласуем вручение с ресепшеном или консьержем и пришлём фото букета перед доставкой.",
    heroBullets: [
      "Букет в номер к заезду или к возвращению вечером",
      "Вручение через ресепшен, консьержа или напрямую гостю",
      "Отели на Пасео де Грасия, в Эшампле, Готике и Барселонете",
      "Доставка в тот же день по всему городу",
      "Фото готового букета до вручения",
      "Оплата картой любой страны, криптовалютой или переводом",
    ],
    cta: "Выбрать букет в отель",
    catalogHeading: "Букеты, которые чаще всего заказывают в отели",
    catalogNote: "Стойкие средиземноморские композиции — цены в евро.",
    fullCatalog: "Смотреть весь каталог Барселоны →",
    sections: [
      {
        h2: "Как мы доставляем цветы в отели Барселоны",
        answer:
          "Мы привозим букет прямо в отель и согласуем вручение так, как удобно вам: в номер, на ресепшен или лично гостю в оговорённое время.",
        paras: [
          "Достаточно указать название отеля, район и имя гостя (или номер брони). Для сюрприза доставим, не раскрывая отправителя, — оставьте контакт получателя, и курьер аккуратно всё организует.",
          "Барселона компактнее многих столиц, поэтому по центру доставка обычно быстрая. В Готическом квартале и Эль-Борне улицы узкие и пешеходные — вручение согласуем с ресепшеном. Перед выездом курьера пришлём фото готовой композиции.",
        ],
        table: {
          head: ["Район отелей", "Ориентир", "Срок в день заказа"],
          rows: [
            ["Пасео де Грасия и Эшампле", "люксовые и бизнес-отели, модернизм Гауди", "1–2 часа"],
            ["Готический квартал и Эль-Борн", "бутик-отели в старом городе", "1–2 часа"],
            ["Барселонета и набережная", "пляжные и панорамные отели", "1–3 часа"],
            ["Диагональ, Сантс, Лес-Кортс", "деловые отели, район Камп Ноу", "1–2 часа"],
            ["Побленоу и Диагональ Мар", "отели у моря и бизнес-парков", "2–3 часа"],
          ],
        },
      },
      {
        h2: "Поводы заказать цветы в отель в Барселоне",
        answer:
          "Чаще всего к нам обращаются, чтобы сделать приезд или особый день в отеле по-настоящему запоминающимся.",
        bullets: [
          "Романтический сюрприз к заезду пары — букет и лепестки в номере",
          "Годовщина или предложение руки и сердца в отеле на набережной",
          "Встреча гостя из аэропорта Эль-Прат — цветы уже ждут в номере",
          "Деловой приём партнёра в отеле на Диагональ или Пасео де Грасия",
          "День рождения на отдыхе — композиция и открытка к завтраку",
        ],
        note: "Добавим открытку, шары или сладости по запросу и согласуем момент вручения.",
      },
    ],
    glanceTitle: "Коротко о доставке в отели",
    glance: [
      { label: "Куда", value: "Отели по всей Барселоне" },
      { label: "Сроки", value: "В день заказа, 1–3 часа" },
      { label: "Цены", value: "Букеты от €98, премиум от €500" },
      { label: "Вручение", value: "В номер, на ресепшен или гостю" },
      { label: "Оплата", value: "Карта, крипто, перевод — из любой страны" },
      { label: "Контроль", value: "Фото букета перед доставкой" },
    ],
    faqTitle: "Частые вопросы о доставке цветов в отели Барселоны",
    faq: [
      { q: "Доставите ли вы букет прямо в номер отеля?", a: "Да. Мы согласуем с ресепшеном или консьержем вручение в номер, либо передадим букет гостю лично в оговорённое время. Укажите название отеля, район и имя гостя или номер брони." },
      { q: "Можно ли сделать сюрприз, чтобы гость не знал заранее?", a: "Да. Оставьте контакт получателя — курьер деликатно всё организует и не раскроет отправителя. По желанию открытку оставим анонимной или подпишем как вы попросите." },
      { q: "В какие отели Барселоны вы возите цветы?", a: "В отели по всему городу: Пасео де Грасия и Эшампле, Готический квартал и Эль-Борн, Барселонету и набережную, деловые районы Диагональ, Сантс и Лес-Кортс, а также Побленоу и Диагональ Мар." },
      { q: "Сколько стоит букет в отель?", a: "Компактные букеты — от €98, средние — €298–498, премиальные из роз и орхидей — от €500. Доставка по городу обычно включена. Цены в евро." },
      { q: "Как быстро доставите?", a: "По центральным районам — обычно за 1–2 часа после подтверждения, по набережной и удалённым отелям — за 1–3 часа. В Готическом квартале вручение согласуем с ресепшеном из-за пешеходных улиц." },
      { q: "Как оплатить из другой страны?", a: "Картой любого банка мира, криптовалютой или переводом. Заказать сюрприз в отель Барселоны можно из любой точки мира, ещё до прибытия." },
    ],
    relatedTitle: "Смотрите также",
    related: [
      { label: "Каталог цветов в Барселоне", href: "/barcelona" },
      { label: "Как работает международная доставка цветов", href: "/blog/kak-rabotaet-dostavka-cvetov" },
      { label: "Цветы в Ибице", href: "/ibiza" },
      { label: "Цветы в Валенсии", href: "/valencia" },
    ],
  },
  en: {
    metaTitle: "Flower Delivery to Barcelona Hotels — Bouquet in the Room | YUCCA",
    metaDescription:
      "Flower delivery to Barcelona hotels: a bouquet in the room on arrival, an anniversary surprise, hand-over via reception. Hotels on Passeig de Gràcia, in the Gothic Quarter, Eixample and Barceloneta. Photo before hand-over, payment from any country. Order on WhatsApp.",
    waCity: "in Barcelona",
    breadcrumb: { home: "Home", city: "Barcelona", current: "Flowers to Hotels" },
    h1: "Flower Delivery to Barcelona Hotels",
    heroLead:
      "Want a bouquet waiting in the room when a loved one arrives, greeting guests at reception, or surprising someone for an anniversary at a Barcelona hotel? YUCCA Flowers delivers fresh flowers to hotels across the whole city — from luxury hotels on Passeig de Gràcia and boutique hotels in the Gothic Quarter to the beach hotels of Barceloneta. We coordinate hand-over with reception or the concierge and send a photo of the bouquet before delivery.",
    heroBullets: [
      "A bouquet in the room on arrival or for the evening return",
      "Hand-over via reception, the concierge or directly to the guest",
      "Hotels on Passeig de Gràcia, in Eixample, the Gothic Quarter and Barceloneta",
      "Same-day delivery across the whole city",
      "A photo of the finished bouquet before hand-over",
      "Payment by card from any country, crypto or transfer",
    ],
    cta: "Choose a bouquet for the hotel",
    catalogHeading: "Bouquets Most Often Ordered to Hotels",
    catalogNote: "Hardy Mediterranean arrangements — prices in euros.",
    fullCatalog: "See the full Barcelona catalog →",
    sections: [
      {
        h2: "How We Deliver Flowers to Barcelona Hotels",
        answer:
          "We bring the bouquet straight to the hotel and arrange hand-over however suits you: to the room, at reception, or in person to the guest at an agreed time.",
        paras: [
          "Just give the hotel name, the district and the guest's name (or booking number). For a surprise we deliver without revealing the sender — leave the recipient's contact and the courier arranges everything discreetly.",
          "Barcelona is more compact than many capitals, so delivery downtown is usually quick. In the Gothic Quarter and El Born the streets are narrow and pedestrian — we coordinate hand-over with reception. Before the courier sets off we send a photo of the finished arrangement.",
        ],
        table: {
          head: ["Hotel area", "Type", "Same-day timing"],
          rows: [
            ["Passeig de Gràcia & Eixample", "luxury & business hotels, Gaudí modernism", "1–2 hours"],
            ["Gothic Quarter & El Born", "boutique hotels in the old town", "1–2 hours"],
            ["Barceloneta & the seafront", "beach & panoramic hotels", "1–3 hours"],
            ["Diagonal, Sants, Les Corts", "business hotels, Camp Nou area", "1–2 hours"],
            ["Poblenou & Diagonal Mar", "hotels by the sea and business parks", "2–3 hours"],
          ],
        },
      },
      {
        h2: "Occasions to Send Flowers to a Barcelona Hotel",
        answer:
          "Most people come to us to make an arrival or a special day at the hotel truly memorable.",
        bullets: [
          "A romantic surprise for a couple's arrival — bouquet and petals in the room",
          "An anniversary or a marriage proposal at a seafront hotel",
          "Greeting a guest from El Prat airport — flowers already waiting in the room",
          "A business welcome for a partner at a Diagonal or Passeig de Gràcia hotel",
          "A birthday on holiday — an arrangement and card for breakfast",
        ],
        note: "We'll add a card, balloons or sweets on request and coordinate the moment of hand-over.",
      },
    ],
    glanceTitle: "Hotel Delivery at a Glance",
    glance: [
      { label: "Where", value: "Hotels across all of Barcelona" },
      { label: "Timing", value: "Same-day, 1–3 hours" },
      { label: "Prices", value: "Bouquets from €98, premium from €500" },
      { label: "Hand-over", value: "To the room, reception or the guest" },
      { label: "Payment", value: "Card, crypto, transfer — from any country" },
      { label: "Control", value: "Photo of the bouquet before delivery" },
    ],
    faqTitle: "FAQ — Flower Delivery to Barcelona Hotels",
    faq: [
      { q: "Will you deliver the bouquet straight to the hotel room?", a: "Yes. We coordinate room delivery with reception or the concierge, or hand the bouquet to the guest in person at an agreed time. Give the hotel name, district and the guest's name or booking number." },
      { q: "Can I make it a surprise so the guest doesn't know?", a: "Yes. Leave the recipient's contact — the courier arranges everything discreetly and won't reveal the sender. On request we keep the card anonymous or sign it as you wish." },
      { q: "Which Barcelona hotels do you deliver to?", a: "Hotels across the whole city: Passeig de Gràcia and Eixample, the Gothic Quarter and El Born, Barceloneta and the seafront, the business districts of Diagonal, Sants and Les Corts, plus Poblenou and Diagonal Mar." },
      { q: "How much does a bouquet to a hotel cost?", a: "Compact bouquets from €98, medium €298–498, premium rose-and-orchid arrangements from €500. City delivery is usually included. Prices are in euros." },
      { q: "How fast can you deliver?", a: "To central districts usually within 1–2 hours of confirmation, and 1–3 hours to the seafront and outer hotels. In the Gothic Quarter we coordinate hand-over with reception because of the pedestrian streets." },
      { q: "How can I pay from abroad?", a: "By card from any bank worldwide, cryptocurrency or transfer. You can arrange a surprise to a Barcelona hotel from anywhere in the world, even before you arrive." },
    ],
    relatedTitle: "See Also",
    related: [
      { label: "Barcelona flower catalog", href: "/barcelona?lang=en" },
      { label: "How international flower delivery works", href: "/blog/kak-rabotaet-dostavka-cvetov?lang=en" },
      { label: "Flowers in Ibiza", href: "/ibiza?lang=en" },
      { label: "Flowers in Valencia", href: "/valencia?lang=en" },
    ],
  },
};
